import { Option } from '../../models/generic';
import Select from 'react-select';
import { Props as SelectProps } from 'react-select/';

interface Props extends SelectProps {
  options?: [];
  value?: any;
  onChange: (value: any) => void;
  controlId: string;
}

const StudioSelect = ({
  options,
  value,
  controlId,
  onChange,
  ...rest
}: Props) => {
  const getValue = () => {
    let studios: Option[] = [];
    options?.map(({ options }: any) => {
      studios = [...studios.concat(options)];
    });
    return studios.find((s: any) => s.value === value);
  };

  return (
    <Select
      id={controlId}
      isMulti={false}
      options={options}
      value={getValue()}
      onChange={(value: any) => onChange(value.value)}
      className="nemo-select-container"
      classNamePrefix="nemo-select"
      {...rest}
    />
  );
};

export default StudioSelect;
